import { Row, Col, ClassifyStructure, Form, message, Card, Transfer, Select, Modal, Input, jsonToQueryString, Button, MainModal, Typography, Tabs, Switch, ExclamationCircleOutlined, Spin, TreeSelect } from '../ui/ot';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { createContext } from 'react';
import { useCRUDController } from '../ui/classify_structure/CRUDController';
import { PermissionListModal } from '../permission_management/permission_list';
import { useDepartmentDepthStaff } from './components/department_depth_staff_modal';
import dayjs from 'dayjs'
import { useDepartmentRoleManagementExcel } from './controllers/department_role_management_excel_controller';

const LanguageContext = createContext(null)
const DepartmentRoleManagement = ({
    keyPrefix = "organization_structure.role",
    mode = 'departmentRole',
    permission_modal_mode = 'group',
    // showMode = "page",

    defaultSelectedRowsInfo = [],
    defaultSelectedRowsKeys = [],
    onSelectChange = () => { },
    // onChange = () => { },
    // value
    customFormItems = () => { }, //上層可加入自定義的form item 
    departmentApi = '/queue_management/backend/department_queue_mgnt', //department 的api 名稱
    customColumns = [], //列表編輯模式的顯示columns
    propsCardRender = () => { }, //card 模式要顯示的其他欄位
    propsFirstDepth = '系統角色',
    propsNameDepartment = '部門(單位)',
    ...props
}) => {
    const currentRoleId = useRef(null)
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix })
    const actionRef = useRef(null)
    const [searchParams] = useSearchParams()
    const departmentIdExternal = searchParams?.get('department_id')
    const navigate = useNavigate()
    const [departmentData, setDepartmentData] = useState([]);
    const [departmentOption, setDepartmentOption] = useState([]);
    const [userData, setUserData] = useState([]);
    const [departmentProcessData, setDepartmentProcessData] = useState([]);
    const [roleProcessData, setRoleProcessData] = useState([]);
    const [departmentId, setDepartmentId] = useState(null);
    const [roleId, setRoleId] = useState(null);
    const [departmentName, setDepartmentName] = useState([]);
    const [roleName, setRoleName] = useState([]);
    const [targetKeys, setTargetKeys] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const [permissionModalOpen, setPermissionModalOpen] = useState(false);
    const [modalData, setModalData] = useState({
        edit: true,
        prefix: "department",
        languageKey: "department_language_data",
        node: [],
        data: { name: "" }
    });
    const current_department_id = useRef()
    const selectRef = useRef()
    const [forceReload, setForceReload] = useState(0);
    const tabShowMode = useRef("card")
    const [showMode, setShowMode] = useState("card");
    const [loading, setLoading] = useState(true)
    const [modalOpen, setModalOpen] = useState(false);
    const [form] = Form.useForm();
    const [columnRequires, setColumnRequires] = useState([])
    const [chagePassword, setChagePassword] = useState(false)
    const [count, setCount] = useState(0);


    const onReset = () => {
        form.resetFields();
    };

    const addModal = (prefix, languageKey, node) => {
        setModalData((prev) => {
            return {
                edit: false,
                prefix: prefix,
                languageKey: languageKey,
                node: node,
                data: { name: "" }
            }
        })
        setModalShow(true)
    }

    const editModal = (prefix, languageKey, node) => {
        let data = {
            "name": node[`${languageKey}`]?.[0]?.language_culture_value !== undefined
                ? node[`${languageKey}`]?.[0]?.language_culture_value
                : node.name

        }
        setModalData({
            edit: true,
            prefix: prefix,
            languageKey: languageKey,
            node: node,
            data: data
        })
        setModalShow(true)
    }
    const deleteDepartment = (node, classify_structure_type_id) => {
        let url = departmentApi;
        let data = [{
            "department_id": node.department_id,
            "classify_structure_id": 9,
            "classify_structure_type_id": classify_structure_type_id,
        }]
        deleteNode("department", url, data, classify_structure_type_id)

    }

    //刪除訊息、找刪除節點
    const deleteNode = (type, url, data, classify_structure_type_id) => {
        axios
            .delete(url, { data: data })
            .then(response => {
                if (response.data.status === "success") {
                    message.success('刪除成功');
                    if (type === "department") {
                        setDepartmentProcessData([4, "delete", classify_structure_type_id])
                        if (data?.[0]?.department_id === departmentId) {
                            setDepartmentId(null)
                        }
                    }
                    else {
                        setRoleProcessData([4, "delete", classify_structure_type_id])
                        if (data?.[0]?.role_id === roleId) {
                            setRoleId(null)
                        }
                    }
                }
                else {
                    message.error('刪除失敗');
                }
            })
            .catch((error) => {
            })
            .finally(() => {

            })
    };
    const getDepartmentId = (node) => {
        if (node) {
            setDepartmentId(node?.department_id)
            let name = node?.department_language_data[0].language_culture_value
            setDepartmentName(name !== undefined ? name : node?.name)
        }
        else {
            setDepartmentId(null)
        }
    }
    const getRoleId = (node) => {
        if (node) {
            setRoleId(node?.role_id)
            let name = node?.role_language_data[0].language_culture_value
            setRoleName(name !== undefined ? name : node?.name)
        }
        else {
            setRoleId(null)
        }
    }
    const onChange = (newTargetKeys, direction, moveKeys) => {
        setTargetKeys(newTargetKeys);
    };
    const postUserRole = (departmentId, roleId, userIdArray) => {
        let data = [{
            "department_id": departmentId,
            "role_id": roleId,
            "user_id": userIdArray,
        }]
        axios.post('/organization_structure/api/user_role', data)
            .then(response => {
                if (response.data.status === "success") {
                    message.success('儲存成功');
                }
                else {
                    message.error('儲存失敗');
                }
            })
            .catch((error) => {
            })
            .finally(() => {
                setRoleId(undefined)
            })
    };
    const isInteger = (value) => {
        // Convert the value to an integer using parseInt
        let parsedValue = parseInt(value, 10);
        // Check if the parsed value is NaN or not equal to the original value (converted to a string)
        return !isNaN(parsedValue) && parsedValue.toString() === value.toString();
    }

    const renderChildrenData = (data = {}, type = 'page') => {
        let lgxlxxl = 12
        if (type === 'page') {
            lgxlxxl = 24
        }
        let depthData = data?.department_depth_data
        if (depthData?.length === 0 && data.depth < 1) {
            return (<>
                <span style={{ color: 'gray' }}>尚未新增層級資料，請點選修改按鈕進行層級設定</span>
            </>
            )
        }
        return <>
            <Row gutter={[8, 8]} style={{ display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
                {depthData?.map((item, depth) => {
                    return (
                        item?.depth_id !== 0 &&
                        <>
                            <Col xxl={lgxlxxl}
                                xl={lgxlxxl}
                                lg={lgxlxxl}
                                md={24}
                                sm={24}
                                xs={24}
                                style={{ alignItem: 'center' }}>
                                第{item?.depth_id}層級：{item?.name}
                            </Col>
                            <Col xxl={lgxlxxl}
                                xl={lgxlxxl}
                                lg={lgxlxxl}
                                md={24}
                                sm={24}
                                xs={24}
                                style={{ alignItem: 'center' }}>
                                <Row gutter={[8, 8]} style={{ display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
                                    <Col>
                                        <Button
                                            style={{
                                                backgroundColor: '#FFBD73', // 主色：橙色
                                                color: '#5a3a00', // 文字色：深棕色
                                                padding: '10px 20px',
                                                border: 'none',
                                                borderRadius: '5px',
                                            }}
                                            size={"small"}
                                            onClick={(e) => {
                                                navigate('./../depth?' + jsonToQueryString({ department_depth_id: item?.department_depth_id, department_id: item?.department_id }))
                                            }}>資料設定</Button>
                                    </Col>
                                    <Col>
                                        {/* 職位綁定未完成 */}
                                        {/* <BindRoleButton /> */}
                                    </Col>
                                </Row>
                            </Col>
                        </>
                    );
                })
                }
            </Row>
        </>
    }

    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "get") {
                setLoading(false)
            } else if (axiosMode === "post") {
                message.success("新增成功");
                actionRef.current.reloadAndRest();

            } else if (axiosMode === "patch") {
                message.success("修改成功");
                actionRef.current.reloadAndRest();

            } else if (axiosMode === "import") {
                message.success("匯入成功");
                selectRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success("刪除成功");
                actionRef.current.reloadAndRest();
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗");
            } else if (axiosMode === "patch") {
                message.error("修改失敗");
            } else if (axiosMode === "delete") {
                message.error("刪除失敗");
            }
        }
    }
    const onBefore = ({ axiosMode, status, values }) => {
        // setModalLoading(true)
    }

    const rolePropertyJsonController = useCRUDController({
        onBefore,
        onFinish,
        apiRoute: '/organization_structure/api/role_property_json'
    })

    const departmentController = useCRUDController({
        onBefore,
        onFinish,
        apiRoute: '/organization_structure/api/department'
    })

    const {
        open: departmentDepthStaffOpen,
        setOpen: setDepartmentDepthStaffOpen,
        DepartmentDepthStaffModal,
        form: departmentDepthStaffForm,
        handleOnClick: handleOnDepartmentDepthStaffClick,
        DepartmentDepthStaffButton
    } = useDepartmentDepthStaff({})

    useEffect(() => {
        if (userData) {
            axios.get('/organization_structure/api/user_role', {
                params: {
                    department_id: departmentId,
                    role_id: roleId
                }
            })
                .then(response => {
                    let newTargetKeys = []
                    newTargetKeys = response.data['data'].map((map_item, index) => (
                        map_item.user_id.toString()
                    ))
                    setTargetKeys(newTargetKeys)
                })
                .catch((error) => {
                })
                .finally(() => {
                })
        }
    }, [userData])

    useEffect(() => {
        setUserData([])
        if (roleId) {
            axios.get('/organization_structure/api/user')
                .then(response => {
                    let newUserData = []
                    newUserData = response.data?.data?.map((map_item, index) => {
                        return {
                            key: String(map_item.user_id),
                            title: `${map_item.staff_name}-${map_item.serial_name}`
                        }
                    })
                    setUserData(newUserData)
                })
                .catch((error) => {
                })
                .finally(() => {
                })
        }
    }, [roleId])

    const init = async () => {
        let firstDepartment
        await axios.get(departmentApi, {
            params: {
            }
        })
            .then(response => {
                setDepartmentOption(response.data['data'])
                firstDepartment = response.data['data']?.find(_ => true)?.department_id
            })
            .catch((error) => {
            })
            .finally(() => {
            })
        if (departmentIdExternal) {
            current_department_id.current = departmentIdExternal
            setDepartmentId(isInteger(departmentIdExternal) ? parseInt(departmentIdExternal) : departmentIdExternal)
        } else if (firstDepartment) {
            current_department_id.current = firstDepartment
            setDepartmentId(isInteger(firstDepartment) ? parseInt(firstDepartment) : firstDepartment)
        }
    }

    useEffect(() => {
        init()
        rolePropertyJsonController.getData()
        departmentController.getData({
            classify_structure_type_id: 0
        })
    }, [])

    useEffect(() => {
    }, [targetKeys])
    useEffect(() => {
        setForceReload(pre => pre + 1)
    }, [current_department_id.current])

    useEffect(() => {
        setTimeout(() => {
            setCount(pre => pre + 1)
        }, 1000)
    }, [])

    const handleExport = (selectedRowKeys, type = "role") => {
        if (type === "role") {
            const role_id_arr = selectedRowKeys
            // getDepartmentRoleManagementExcelData()
            getDepartmentRoleManagementExcelData({
                role_id_arr: role_id_arr.length !== 0 ? `{${role_id_arr.join(',')}}` : undefined
            })
        } else if (type === "structure") {
            departmentController.exportData()
        }
    }

    const handleImport = ({ file, columns }, type = "role") => {
        if (type === "role") {
            importDepartmentRoleManagementExcelData({ file, columns })
        } else if (type === "structure") {
            departmentController.importData({
                target: {
                    files: [file]
                }
            })
        }
    }

    const handleSample = (type = "role") => {
        if (type === "role") {
            getDepartmentRoleManagementExcelDataSample()
        } else if (type === "structure") {
            departmentController.downloadData()
        }
    }

    const {
        getDepartmentRoleManagementExcelData,
        getDepartmentRoleManagementExcelDataSample,
        importDepartmentRoleManagementExcelData,
    } = useDepartmentRoleManagementExcel({
        onFinish,
    })

    return (<>
        <LanguageContext.Provider value={keyPrefix}>
            <Row gutter={[8, 8]} align={'top'}>
                {(mode === "departmentRole" || mode === 'department' || mode === "structure") && <>
                    <Col span={24}>
                        <Typography.Title level={3}>
                            {propsFirstDepth}{propsNameDepartment ? ` - ${propsNameDepartment}` : ``}設定
                        </Typography.Title>
                    </Col>
                    <PermissionListModal propsOpen={modalOpen} propsSetOpen={setModalOpen} id={current_department_id.current} prefix={'department'} apiRoute={'/organization_structure/api/department_permission'} />
                    <DepartmentDepthStaffModal
                        propsOpen={departmentDepthStaffOpen}
                        propsSetOpen={setDepartmentDepthStaffOpen}
                        propsForm={departmentDepthStaffForm}
                        onOK={() => selectRef.current.reloadAndRest()}
                    />
                    <Col span={mode === "department" || mode === "structure" ? 24 : 12}>
                        <ClassifyStructure
                            selectRef={selectRef}
                            propsForm={form}
                            prefixTitle="department"
                            apiRoute={departmentApi}
                            customColumns={[
                                {
                                    title: '名稱',
                                    dataIndex: 'department_language_data',
                                    key: 'department_language_data',
                                    render: (text, record, index) => (
                                        record[`department_language_data`]?.[0]?.language_culture_value !== undefined
                                            ? record[`department_language_data`]?.[0].language_culture_value
                                            : record.name
                                    )
                                },
                                {
                                    title: '代號',
                                    dataIndex: 'department_code',
                                    key: 'department_code',
                                },
                                {
                                    title: '自動寫入卡機',
                                    dataIndex: 'department_queue_mgnt_department_data',
                                    key: 'department_queue_mgnt_department_data',
                                    render: (text, record, index) => (
                                        // console.log(record)
                                        record[`department_queue_mgnt_department_data`]?.[0]?.auto_in_card_machine !== undefined
                                            ? record[`department_queue_mgnt_department_data`]?.[0].auto_in_card_machine == 1 ? '是' : '否'
                                            : '否'
                                    )
                                },
                                {
                                    title: '層級資訊',
                                    dataIndex: 'department_depth_data',
                                    key: 'department_depth_data',
                                    render: (text, record, index) => (
                                        // record[`department_depth_data`]?.map((item) => {
                                        renderChildrenData(record, 'page')

                                        // })
                                    )
                                },
                                // {
                                //     title: '額外資訊',
                                //     dataIndex: 'property_json',
                                //     key: 'property_json',
                                //     render: (text) => <>
                                //         <Row>
                                //             {Object.keys(text).map(item => <Col span={24}>{item}：{text[item]}</Col>)}
                                //         </Row>
                                //     </>
                                // },
                                ...customColumns,
                                // {
                                //     title: '職位數',
                                //     dataIndex: 'count_role',
                                //     key: 'count_role'
                                // },
                                // {
                                //     title: '人員數',
                                //     dataIndex: 'count_user',
                                //     key: 'count_user'
                                // },
                                {
                                    title: '建立人',
                                    dataIndex: 'create_user_name',
                                    key: 'create_user_name',
                                },
                                {
                                    title: '建立時間',
                                    dataIndex: 'create_time',
                                    key: 'create_time',
                                    render: (text) => dayjs(text).format('YYYY-MM-DD HH:mm')
                                },
                            ]}
                            extraActionRender={(record) => <>
                            </>}
                            propsPostChildren={false}
                            customFormItems={(fieldName, formValues, onValuesChange, propsCustomForm, propsOnValueChange, field, onFormFinish) => <>

                                <Form.Item
                                    name={[field?.name ?? '', "department_id"]}
                                    hidden
                                ></Form.Item>
                                <Form.Item
                                    label={'代號'}
                                    name={[field?.name ?? '', "department_code"]}
                                >
                                    <Input />
                                </Form.Item>
                                <Form.Item
                                    label={'自動寫入卡機'}
                                    name={[field?.name ?? '', "department_queue_mgnt_department_data.0.auto_in_card_machine"]}
                                >
                                    <Switch
                                        checkedChildren="是"
                                        unCheckedChildren="否"
                                        mode={"number"}
                                    />
                                </Form.Item>
                                <Form.Item
                                    name={[field?.name ?? '', "classify_structure_type_id"]}
                                    hidden
                                ></Form.Item>
                                <Form.Item
                                    name={[field?.name ?? '', "department_language_data.0.language_manage_id"]}
                                    hidden
                                ></Form.Item>
                                <Form.Item
                                    name={[field?.name ?? '', "department_language_data.0.language_culture_code"]}
                                    hidden
                                >
                                </Form.Item>
                                <Form.Item
                                    name={[field?.name ?? '', "department_language_data.0.language_culture_value"]}
                                    hidden
                                >
                                </Form.Item>

                                <DepartmentDepthForm field={field} fieldName={field?.name} prefix={'department'} propsForm={propsCustomForm} propsFirstDepth={propsFirstDepth} onFormFinish={onFormFinish} />
                                {customFormItems(fieldName)}
                            </>
                            }
                            propsSort={false}
                            classify_structure_id={9}
                            classify_structure_type_id={0}
                            initialValues={{
                                "department_language_data": [
                                    {
                                        "language_manage_id": undefined,
                                        "language_culture_code": "zh-tw",
                                        "language_culture_value": ""
                                    }
                                ]
                                // permission_id: null,
                                // path_check: 0,
                                // path_check_replace: false,
                                // show_replace: false,
                                // show: 0,
                                // menu_permission_data: [{
                                //     // menu_id: current_department_id?.current
                                // }],
                                // property_json: {
                                //     blod: false,
                                //     italic: false,
                                //     textDecoration: false,
                                //     background_color1: null,
                                //     background_color2: null
                                // }

                            }}
                            reorganizeFormData={(value, type) => {
                                if (type === "submit") {
                                    let newData = [{
                                        ...value,
                                        "children": undefined,
                                        "department_id": value?.department_id,
                                        "department_code": value?.department_code,
                                        "auto_in_card_machine": value?.auto_in_card_machine,
                                        "classify_structure_id": 9,
                                        "classify_structure_type_parent_id": undefined,
                                        "classify_structure_type_id": value?.classify_structure_type_parent_id,
                                        "name": value?.name,
                                        "department_language_data": [
                                            {
                                                "language_manage_id": value?.department_language_data?.[0]?.language_manage_id,
                                                "language_culture_code": "zh-tw",
                                                "language_culture_value": value?.name
                                            }
                                        ],
                                        "department_depth_data": value?.department_depth_data,
                                        "property_json": value?.property_json
                                    }]
                                    let firstData = newData.find((ele) => true)
                                    return {
                                        ...firstData
                                    };
                                } else if (type === "set") {
                                    let newData = [{
                                        ...value,
                                        "department_id": value?.department_id,
                                        "department_code": value?.department_code,
                                        "auto_in_card_machine": value?.auto_in_card_machine,
                                        "department_department_index": 1,
                                        "classify_structure_id": 9,
                                        "name": value?.name,
                                        "department_language_data": [
                                            {
                                                "language_manage_id": value?.department_language_data?.[0]?.language_manage_id,
                                                "language_culture_code": "zh-tw",
                                                "language_culture_value": value?.name
                                            }
                                        ],
                                        "department_depth_data": value?.department_depth_data,
                                        "property_json": value?.property_json
                                    }]
                                    let firstData = newData.find((ele) => true)
                                    return {
                                        ...firstData
                                    };
                                }
                            }}
                            extraParams={{
                                // menu_id: current_department_id.current
                            }}
                            // forceReload={forceReload}
                            chartShow={false}

                            treeData={departmentData}
                            onSubmit={addModal}
                            onChange={editModal}
                            processData={departmentProcessData}
                            deleteNode={deleteDepartment}
                            onSelect={getDepartmentId}
                            chartTitle={'單位組織架構圖'}
                            treeTitle={''}
                            extra_column={[
                                // {
                                //     title: '職位數',
                                //     dataIndex: 'count_role',
                                //     key: 'count_role'
                                // },
                                // {
                                //     title: '人員數',
                                //     dataIndex: 'count_user',
                                //     key: 'count_user'
                                // },
                            ]}
                            link={(record) => {
                                navigate('./../role?' + jsonToQueryString({ department_id: record?.department_id }))
                            }}
                            showMode={showMode}
                            cardRender={(record, { PatchButton, DeleteButton }) => {
                                return <>
                                    <Card title={`${propsFirstDepth}：${record.title}`}
                                        styles={{
                                            padding: 8,
                                            height: "400px",
                                            overflow: 'scroll'
                                        }}
                                    >
                                        <Row gutter={[8, 8]} style={{ display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
                                            <Col>
                                                {PatchButton}
                                            </Col>
                                            <Col>
                                                {DeleteButton}
                                            </Col>
                                            {mode !== "structure" && <Col>
                                                <Button
                                                    style={{
                                                        color: '#000000',
                                                        backgroundColor: "#E2DAD6",
                                                    }}
                                                    onClick={() => {
                                                        current_department_id.current = record?.department_id
                                                        setModalOpen(true)
                                                    }}>
                                                    統一權限設定
                                                </Button>
                                            </Col>}
                                            {mode === "department" && <Col>
                                                <DepartmentDepthStaffButton
                                                    value={record?.department_depth_data?.find(item => item?.depth_id === 0)?.department_depth_staff_data}
                                                    handleOnClick={() => {
                                                        const department_depth_data = record?.department_depth_data?.find(item => item?.depth_id === 0)
                                                        departmentDepthStaffForm.resetFields()
                                                        departmentDepthStaffForm.setFieldsValue({ ...department_depth_data })
                                                        handleOnDepartmentDepthStaffClick()
                                                    }}>
                                                </DepartmentDepthStaffButton>
                                            </Col>}
                                            <Col span={24}>
                                                {propsCardRender(record)}
                                            </Col>
                                            <Col span={24}>
                                                {renderChildrenData(record, 'card')}
                                            </Col>
                                        </Row>
                                    </Card>
                                </>
                            }}
                            cardModeSetting={{
                                columnsCount: 2,
                                singleRowHeight: '100vh',
                            }}
                            toolBarRender={(tools) => {
                                return [
                                    <Col>
                                        <Tabs
                                            items={[
                                                {
                                                    key: "card",
                                                    tab: '區塊呈現'
                                                },
                                                {
                                                    key: "page",
                                                    tab: '列表呈現'
                                                },
                                            ]}
                                            onChange={(value) => {
                                                tabShowMode.current = value
                                                setShowMode(value)

                                                // if (departmentId === undefined) {
                                                //     getDepartmentDepthData({ department_id: 0 })
                                                // } else {
                                                //     getDepartmentDepthData({ department_id: departmentId })
                                                // }
                                            }}
                                        />
                                    </Col>,
                                    ...tools
                                ]
                            }}
                            propsExport
                            propsImport
                            propsHandleOuter={false}
                            formMode={true}
                        />
                    </Col>
                </>}
                {(mode === "departmentRole" || mode === 'role') && <>
                    <Col span={24}>
                        <Typography.Title level={3}>
                            角色身份管理
                        </Typography.Title>
                    </Col>
                    <Col span={mode === "role" ? 24 : 12}>

                        <Row gutter={[8, 8]} align={'top'}>
                            {false && <>
                                <Col>
                                    目前編輯所屬單位：
                                </Col>
                                <Col>
                                    <Select
                                        options={departmentOption.map(item => {
                                            return {
                                                label: item?.department_language_data?.find(item => item.language_culture_code === "zh-tw")?.language_culture_value || item.title,
                                                value: item.department_id
                                            }
                                        })}
                                        value={departmentId}
                                        onChange={(e) => {
                                            setDepartmentId(e)
                                            current_department_id.current = e
                                        }}
                                        defaulDisabled={true}
                                    />
                                </Col>
                            </>}
                            <Col span={24}>
                                {
                                    !loading && <>
                                        <PermissionListModal propsOpen={permissionModalOpen} propsSetOpen={setPermissionModalOpen} key={currentRoleId.current} id={currentRoleId.current} prefix={'role'} apiRoute={'/organization_structure/api/role_permission'} />


                                        <ClassifyStructure
                                            selectRef={selectRef}
                                            propsForm={form}
                                            prefixTitle="role"
                                            apiRoute='/queue_management/backend/role_queue_mgnt'
                                            customColumns={[
                                                {
                                                    title: '名稱',
                                                    dataIndex: 'name',
                                                    key: 'name',
                                                    render: (text, record, index) => (
                                                        record[`role_language_data`]?.[0]?.language_culture_value !== undefined
                                                            ? record[`role_language_data`]?.[0].language_culture_value
                                                            : record.name
                                                    )
                                                },
                                                {
                                                    title: '代號',
                                                    dataIndex: 'role_code',
                                                    key: 'role_code'
                                                },
                                                {
                                                    title: '自動寫入卡機',
                                                    dataIndex: 'role_queue_mgnt_role_data',
                                                    key: 'role_queue_mgnt_role_data',
                                                    render: (text, record, index) => (
                                                        record[`role_queue_mgnt_role_data`]?.[0]?.auto_in_card_machine !== undefined
                                                            ? record[`role_queue_mgnt_role_data`]?.[0].auto_in_card_machine == 1 ? '是' : '否'
                                                            : '尚未設定'
                                                    )
                                                },
                                                ...Object.keys(rolePropertyJsonController.ResponseData?.find(_ => true)?.property_json ?? {})?.map((key, index) => {
                                                    return {
                                                        title: key,
                                                        dataIndex: key,
                                                        key: key,
                                                        render: (text, record) => {
                                                            return record?.property_json?.[key]
                                                        }
                                                    }
                                                }),
                                                {
                                                    title: '建立人',
                                                    dataIndex: 'create_user_name',
                                                    key: 'create_user_name',
                                                },
                                                {
                                                    title: '建立時間',
                                                    dataIndex: 'create_time',
                                                    key: 'create_time',
                                                },
                                            ]}
                                            propsSort={true}
                                            extraActionRender={(record) => <>
                                                <Col span={24}>
                                                    <Row gutter={[8, 8]}>

                                                        <Col>
                                                            <Button
                                                                style={{
                                                                    color: '#000000',
                                                                    backgroundColor: "#E2DAD6",
                                                                }}
                                                                onClick={() => {
                                                                    currentRoleId.current = record?.role_id
                                                                    setPermissionModalOpen(true)
                                                                }}>
                                                                統一權限設定
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </>}
                                            customFormItems={(fieldName, formValues, onValuesChange, propsCustomForm, propsOnValueChange, field, onFormFinish) => {
                                                return <>
                                                    <Form.Item
                                                        name={[field?.name ?? '', "role_id"]}
                                                        hidden
                                                    ></Form.Item>
                                                    <Form.Item
                                                        label={'代號'}
                                                        name={[field?.name ?? '', "role_code"]}
                                                        rules={[{ required: true, message: `此為必填項目`, },]}
                                                    >
                                                        <Input />
                                                    </Form.Item>
                                                    <Form.Item
                                                        label={'自動寫入卡機'}
                                                        name={[field?.name ?? '', "role_queue_mgnt_role_data.0.auto_in_card_machine"]}
                                                    >
                                                        <Switch
                                                            checkedChildren="是"
                                                            unCheckedChildren="否"
                                                            mode={'number'}
                                                        />
                                                    </Form.Item>
                                                    <Form.Item
                                                        name={[field?.name ?? '', "department_id"]}
                                                        hidden
                                                    ></Form.Item>
                                                    <Form.Item
                                                        name={[field?.name ?? '', "classify_structure_type_id"]}
                                                        hidden
                                                    ></Form.Item>
                                                    <Form.Item
                                                        name={[field?.name ?? '', "role_language_data.0.language_manage_id"]}
                                                        hidden
                                                    ></Form.Item>
                                                    <Form.Item
                                                        name={[field?.name ?? '', "role_language_data.0.language_culture_code"]}
                                                        hidden
                                                    >
                                                    </Form.Item>
                                                    <Form.Item
                                                        name={[field?.name ?? '', "role_language_data.0.language_culture_value"]}
                                                        hidden
                                                    >
                                                    </Form.Item>
                                                    <Form.Item
                                                        name={[field?.name ?? '', "role_queue_mgnt_role_data.0.role_queue_mgnt_role_id"]}
                                                        hidden
                                                    >
                                                    </Form.Item>
                                                    <Form.Item
                                                        name={[field?.name ?? '', "role_queue_mgnt_role_data.0.role_queue_mgnt_id"]}
                                                        hidden
                                                    >
                                                    </Form.Item>
                                                    {departmentController.ResponseData?.length > 0 && <Form.List
                                                        key={count}
                                                        label={'綁定結構'}
                                                        name={[field?.name ?? '', "department_role_data"]}
                                                        rules={[
                                                            {
                                                                required: columnRequires.includes("department_role"),
                                                                message: `此為必填項目`
                                                            }
                                                        ]}
                                                    >
                                                        {(subFields, { add, remove }) => (
                                                            <Row gutter={[8, 8]} style={{ display: 'flex', justifyContent: 'end' }}>
                                                                <Col span={18} >
                                                                    <Button
                                                                        style={{ width: '100%' }}
                                                                        onClick={
                                                                            () => {
                                                                                add();
                                                                            }
                                                                        }>{'新增結構'}</Button>
                                                                </Col>
                                                                {subFields?.map((subField, key) => (<>
                                                                    <Col span={10}>
                                                                        <Form.Item
                                                                            key={subField.id}
                                                                            wrapperCol={12}
                                                                            labelCol={12}
                                                                            label={`${'系統結構'} - ${key + 1}`}
                                                                            name={[subField.name, "department_id"]}
                                                                            rules={[
                                                                                {
                                                                                    required: columnRequires.includes(""),
                                                                                    message: `此為必填項目`
                                                                                }
                                                                            ]}
                                                                        >
                                                                            <Select
                                                                                options={departmentController.ResponseData?.map(department => (
                                                                                    {
                                                                                        label: department?.department_language_data?.filter(itemItemItem => itemItemItem.language_culture_code === "zh-tw").map(itemItemItem =>
                                                                                            itemItemItem?.language_culture_value
                                                                                        ),
                                                                                        value: department?.department_id
                                                                                    }
                                                                                ))}
                                                                            />
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col span={6}>
                                                                        <Form.Item
                                                                            key={subField.id}
                                                                            labelCol={14}
                                                                            wrapperCol={10}
                                                                            label={`${'帳號編碼'}`}
                                                                            name={[subField.name, "role_serial_name_encode"]}
                                                                            rules={[
                                                                                {
                                                                                    required: columnRequires.includes(""),
                                                                                    message: `此為必填項目`
                                                                                }
                                                                            ]}
                                                                        >
                                                                            <Switch
                                                                                checkedChildren={'是'}
                                                                                unCheckedChildren={'否'}
                                                                                mode={'number'}
                                                                            />
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col span={6}>
                                                                        <Form.Item
                                                                            key={subField.id}
                                                                            labelCol={12}
                                                                            wrapperCol={12}
                                                                            label={`${'管理結構內資料'}`}
                                                                            name={[subField.name, "department_role_manage"]}
                                                                            rules={[
                                                                                {
                                                                                    required: columnRequires.includes(""),
                                                                                    message: `此為必填項目`
                                                                                }
                                                                            ]}
                                                                        >
                                                                            <Switch
                                                                                checkedChildren={'是'}
                                                                                unCheckedChildren={'否'}
                                                                                mode={'number'}
                                                                            />
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col span={2}>
                                                                        <Button
                                                                            onClick={() => {
                                                                                Modal.confirm({
                                                                                    title: '確定要刪除嗎',
                                                                                    icon: <ExclamationCircleOutlined />,
                                                                                    okText: '確定',
                                                                                    okType: 'danger',
                                                                                    cancelText: '取消',
                                                                                    onOk() {
                                                                                        remove(subField.id);
                                                                                    },
                                                                                    centered: true
                                                                                });
                                                                            }}> 刪除
                                                                        </Button>
                                                                    </Col>
                                                                </>))}
                                                            </Row>
                                                        )}
                                                    </Form.List>}
                                                    {customFormItems(fieldName, formValues, onValuesChange, propsCustomForm, propsOnValueChange, field, onFormFinish)}
                                                    <Form.Item
                                                        name={[field?.name ?? '', "property_json"]}
                                                    >
                                                        <PropertyJson actionMode={"postValue"} />
                                                    </Form.Item>
                                                </>
                                            }}
                                            classify_structure_id={8}
                                            classify_structure_type_id={0}
                                            initialValues={{
                                                "role_language_data": [
                                                    {
                                                        "language_manage_id": undefined,
                                                        "language_culture_code": "zh-tw",
                                                        "language_culture_value": ""
                                                    }
                                                ]
                                                // permission_id: null,
                                                // path_check: 0,
                                                // path_check_replace: false,
                                                // show_replace: false,
                                                // show: 0,
                                                // menu_permission_data: [{
                                                //     // menu_id: current_department_id?.current
                                                // }],
                                                // property_json: {
                                                //     blod: false,
                                                //     italic: false,
                                                //     textDecoration: false,
                                                //     background_color1: null,
                                                //     background_color2: null
                                                // }

                                            }}
                                            reorganizeFormData={(value, type) => {
                                                if (type === "submit") {
                                                    let newData = [{
                                                        "role_id": value?.role_id,
                                                        "role_code": value?.role_code,
                                                        "auto_in_card_machine": value?.auto_in_card_machine,
                                                        "department_id": undefined,
                                                        "department_role_index": 1,
                                                        "classify_structure_id": 8,
                                                        "classify_structure_type_parent_id": value?.classify_structure_type_parent_id,
                                                        "classify_structure_type_id": value?.classify_structure_type_id,
                                                        "name": value?.name,
                                                        "department_role_data": value?.department_role_data,
                                                        "role_queue_mgnt_role_data": [
                                                            {
                                                                'role_queue_mgnt_role_id': value?.role_queue_mgnt_role_data?.[0]?.role_queue_mgnt_role_id,
                                                                'auto_in_card_machine': value?.role_queue_mgnt_role_data?.[0]?.auto_in_card_machine,
                                                            }
                                                        ],
                                                        "role_language_data": [
                                                            {
                                                                "language_manage_id": value?.role_language_data?.[0]?.language_manage_id,
                                                                "language_culture_code": "zh-tw",
                                                                "language_culture_value": value?.name
                                                            }
                                                        ],
                                                        "property_json": value?.property_json
                                                    }]
                                                    let firstData = newData.find((ele) => true)
                                                    return {
                                                        ...firstData
                                                    };
                                                } else if (type === "set") {
                                                    let newData = [{
                                                        "role_id": value?.role_id,
                                                        "role_code": value?.role_code,
                                                        "auto_in_card_machine": value?.auto_in_card_machine,
                                                        "department_id": undefined,
                                                        "department_id_arr": undefined,
                                                        "department_role_index": 1,
                                                        "classify_structure_id": 8,
                                                        "classify_structure_type_id": value?.classify_structure_type_parent_id,
                                                        "name": value?.name,
                                                        "department_role_data": value?.department_role_data,
                                                        "role_queue_mgnt_role_data": [
                                                            {
                                                                'role_queue_mgnt_role_id': value?.role_queue_mgnt_role_data?.[0]?.role_queue_mgnt_role_id,
                                                                'role_queue_mgnt_id': value?.role_queue_mgnt_role_data?.[0]?.role_queue_mgnt_id,
                                                                'auto_in_card_machine': value?.role_queue_mgnt_role_data?.[0]?.auto_in_card_machine,
                                                            }
                                                        ],
                                                        "role_language_data": [
                                                            {
                                                                "language_manage_id": value?.role_language_data?.[0]?.language_manage_id,
                                                                "language_culture_code": "zh-tw",
                                                                "language_culture_value": value?.name
                                                            }
                                                        ],
                                                        "property_json": value?.property_json
                                                    }]
                                                    let firstData = newData.find((ele) => true)
                                                    return {
                                                        ...firstData
                                                    };
                                                }
                                            }}
                                            extraParams={{
                                                // "department_id": current_department_id.current,
                                                only: true,
                                                all: true
                                            }}
                                            // forceReload={forceReload}
                                            toolBarRender={(tools) => {
                                                return [
                                                    // <DefaultRoleModal />,
                                                    ...tools,
                                                    <ColumnExtendButton />
                                                ]
                                            }}
                                            defaultSelectedRowsInfo={defaultSelectedRowsInfo}
                                            defaultSelectedRowsKeys={defaultSelectedRowsKeys}
                                            onSelectChange={onSelectChange}
                                            chartShow={true}
                                            chartRoot={'系統職位'}
                                            formMode={true}
                                            chartTitle={'系統角色身份'}
                                            propsExport
                                            propsHandleExport={handleExport}
                                            propsImport
                                            propsHandleImport={handleImport}
                                            propsHandleSample={() => handleSample("role")}
                                            propsWidth={1200}
                                        />
                                    </>
                                }

                                {/* </>)} */}
                            </Col>
                        </Row>
                        <Col span={24}>
                            {departmentId && roleId && (<>
                                <Modal
                                    contentStyle={{
                                        padding: 16
                                    }}
                                    open={true}
                                    title={`${roleName} - 人員管理`}
                                    okText='儲存'
                                    cancelText='取消'
                                    onOk={() => {
                                        form.submit()
                                    }}
                                    onCancel={() => {
                                        setRoleId(undefined)
                                    }}
                                >
                                    <Form
                                        name="basic"
                                        initialValues={{ remember: true }}
                                        autoComplete="off"
                                        layout="vertical"
                                        form={form}
                                        onFinish={(values) => {
                                            onReset()
                                            postUserRole(departmentId, roleId, targetKeys)
                                        }}
                                    >
                                        {/* <Row justify={"end"}>
                                            <Button type="primary" onClick={() => form.submit()}>
                                                儲存
                                            </Button>
                                        </Row> */}
                                    </Form>
                                    <Transfer
                                        dataSource={userData}
                                        targetKeys={targetKeys}
                                        onChange={onChange}
                                        render={(item) => item.title}
                                        showSearch={true}
                                        pagination
                                        listStyle={{
                                            height: 300,
                                        }}
                                    />
                                </Modal>
                            </>
                            )}
                        </Col>
                    </Col>
                </>}
            </Row>
        </LanguageContext.Provider>
    </>)
}
export default DepartmentRoleManagement;

const PropertyJson = ({
    value,
    onChange,
    actionMode = "postColumn",
    ...props
}) => {
    const [count, setCount] = useState(0);
    const [columnRequires, setColumnRequires] = useState([]);
    const [form] = Form.useForm();
    const setFormValuesOtherThings = (values) => {
        //做一些你可能會用到其他component的資料整理
        const result = values?.property_json?.reduce((acc, curr) => {
            acc[curr.type] = curr.name;
            return acc;
        }, {});
        onChange({
            target: {
                name: props?.name,
                value: {
                    ...result,
                }
            }
        })
        props?.onValueChange({
            target: {
                name: props?.name,
                value: {
                    ...result,
                }
            }
        })
    };
    useEffect(() => {
        form.setFieldsValue({
            property_json: Object.entries(value).map(([type, name]) => (
                {
                    type,
                    name
                }
            ))
        })
    }, [value])
    return <>
        <Form
            form={form}
            onValuesChange={(values) => {
                setFormValuesOtherThings(values)
            }}
        >
            <Form.List
                name={"property_json"}
            >
                {(fields, { add, remove }) => <>
                    {actionMode === "postColumn" ?
                        <Button onClick={() => {
                            add()
                        }}>新增欄位</Button>
                        : <></>}
                    {fields.map((field, index) => <>
                        {actionMode === "postColumn" ?
                            <Row gutter={[8, 8]}>
                                <Col span={10}>
                                    <Form.Item
                                        label={'欄位名稱'}
                                        name={[field.name, "type"]}
                                    >
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={10}>
                                    <Form.Item
                                        label={'欄位預設內容'}
                                        name={[field.name, "name"]}
                                    >
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={4}>
                                    <Button
                                        type={'danger'}
                                        onClick={() => {
                                            remove(index)
                                            const values = form.getFieldsValue();
                                            setFormValuesOtherThings(values)
                                        }}
                                    >刪除欄位</Button>
                                </Col>
                            </Row>
                            :
                            <>
                                <Form.Item
                                    hidden
                                    label={'欄位名稱'}
                                    name={[field.name, "type"]}
                                    rules={[
                                        {
                                            required: true,
                                            message: `此為必填項目`,
                                        },
                                    ]}
                                >
                                    <Input />
                                </Form.Item>
                                <Form.Item
                                    label={form.getFieldValue([field.name, "type"])}
                                    name={[field.name, "name"]}
                                >
                                    <Input />
                                </Form.Item>
                            </>}
                    </>)}
                </>}
            </Form.List>
        </Form>
    </>
}
export { PropertyJson }

const DepartmentDepthForm = ({
    propsForm = null,
    formReloadCount = 0,
    onFormFinish = () => { },
    prefix = "",
    record = {},
    field,
    fieldName = field?.name,
    propsFirstDepth = '系統角色'
}) => {
    const [form_] = Form.useForm();
    const form = propsForm || form_

    const setFormValuesOtherThings = (formValues) => {
        //做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
            // total: (formValues?.comments * formValues?.number) || 0
        }
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues)
        }
        else {
            form.setFieldsValue(newFormValues)
        }

    }
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
    }
    const onFinish = (values) => {
        onFormFinish(values?.[prefix + '_depth_data'] || [])
        // let news_time = dayjs(values?.news_time).format("YYYY-MM-DD HH:mm:ss")
        // let announce_time_end = dayjs(values?.announce_time_end).format("YYYY-MM-DD HH:mm:ss")
        // onFormFinish({
        //     ...values,
        //     news_time,
        //     announce_time_end
        // })

    }
    const onValuesChange = () => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
        // setFormValuesOtherThings(formValues)
    }

    useEffect(() => {
        setDataInitialization()
    }, [])
    useEffect(() => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
        (propsForm ?? form).setFieldsValue(formValues)
    }, [formReloadCount])

    const data = Form.useWatch(fieldName ? [fieldName ?? '', prefix + '_depth_data'].join('.') : prefix + '_depth_data', (propsForm ?? form))
    return (
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                // initialValues={{
                //     [fieldName ? [fieldName ?? '', prefix + '_depth_data'].join('.') : prefix + '_depth_data']: [{
                //         depth_id: 0,
                //         name: '系統角色'
                //     }]
                // }}
                >
                    <Form.List
                        name={fieldName ? [fieldName ?? '', prefix + '_depth_data'].join('.') : prefix + '_depth_data'}>
                        {(subFields, { add, remove }) => <>
                            <Row justify={'end'}>
                                <Col>
                                    <Button onClick={() => add(
                                        subFields.length === 0 ? [{
                                            [prefix + '_id']: record?.[prefix + '_id'],
                                            depth_id: (subFields.length),
                                            name: propsFirstDepth
                                        }, {
                                            [prefix + '_id']: record?.[prefix + '_id'],
                                            depth_id: (subFields.length + 1)
                                        }] : {
                                            [prefix + '_id']: record?.[prefix + '_id'],
                                            depth_id: (subFields.length)
                                        })}>新增層級</Button>
                                </Col>
                            </Row>
                            {subFields.map((subField, index) => <>
                                <Row gutter={[8, 8]}>
                                    <Col span={24}>
                                        <Form.Item
                                            hidden={true}
                                            name={[subField.name, prefix + "_depth_id"]}
                                        >
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item
                                            hidden={true}
                                            name={[subField.name, "depth_id"]}
                                        >
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item
                                            hidden={true}
                                            name={[subField.name, prefix + "_id"]}
                                        >
                                        </Form.Item>
                                    </Col>
                                    {index !== 0 &&
                                        <Col span={24}>
                                            <Row justify={'end'} gutter={[8, 8]}>
                                                <Col span={12}>
                                                    <Form.Item
                                                        label={`第${(index)}層級標題`}
                                                        name={[subField.name, "name"]}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: "請輸入"
                                                            }
                                                        ]}
                                                    >
                                                        <Input>
                                                        </Input>
                                                    </Form.Item>
                                                </Col>
                                                <Col>
                                                    <Button
                                                        type={'danger'}
                                                        onClick={() => remove(index)}
                                                        style={subFields.length - 1 === index ? {} : {
                                                            display: 'none'
                                                        }}
                                                    >刪除</Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                    }
                                </Row>
                            </>)}
                        </>}
                    </Form.List>
                </Form>
            </Col>
        </Row>
    )
}

const ColumnExtendButton = ({
    keyPrefix
}) => {
    const [form] = Form.useForm();
    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false)
    const actionRef = useRef(null)

    const onFormFinish = (value) => {
        let { ...formValues } = form.getFieldsValue()
        rolePropertyJsonController.patchData([formValues]);
    }

    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "get") {
            } else if (axiosMode === "post") {
                message.success("新增成功");
                actionRef.current.reloadAndRest();

            } else if (axiosMode === "patch") {
                message.success("修改成功");
                actionRef.current.reloadAndRest();

            } else if (axiosMode === "delete") {
                message.success("刪除成功");
                actionRef.current.reloadAndRest();

            }
            if (axiosMode !== "get") {
                setModalOpen(false);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗");
            } else if (axiosMode === "patch") {
                message.error("修改失敗");
            } else if (axiosMode === "delete") {
                message.error("刪除失敗");
            }
            setModalOpen(false);
        }
    }
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    }
    const rolePropertyJsonController = useCRUDController({
        onBefore,
        onFinish,
        apiRoute: '/organization_structure/api/role_property_json'
    })
    useEffect(() => {
        const values = rolePropertyJsonController.ResponseData
        if (values.length !== 0) {
            form.setFieldsValue({ ...values?.find(_ => true) })
        }
    }, [rolePropertyJsonController.ResponseData])
    useEffect(() => {
        rolePropertyJsonController.getData()
    }, [])
    return (
        <>
            <Button
                type="primary"
                style={{
                    color: "#000",
                    backgroundColor: "#C5D3E8",
                }}
                onClick={(e) => { setModalOpen(true) }}
            >
                欄位擴充設定
            </Button>
            <MainModal
                axiosMode="patch"
                propsForm={form}
                propsOpen={modalOpen}
                propsSetOpen={setModalOpen}
                onFinish={onFormFinish}
                width={1000}
                formElement={<ColumnExtendForm></ColumnExtendForm>}
                keyPrefix={keyPrefix}
            />
        </>
    )
}

const ColumnExtendForm = ({
    propsForm = null,
    propsValue = null,
    formReloadCount = 0,
    onFormFinish = () => { },
    customFormItems = () => { },
    defaultValue = {},
    propsOnValuesChange = () => { },
    fieldName
}) => {
    const [form] = Form.useForm();
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });
    };

    const onValuesChange = (value, { name, type }) => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldsValue();
        } else {
            formValues = form.getFieldsValue();
        }
        propsOnValuesChange(formValues)
    };

    useEffect(() => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldsValue();
        } else {
            formValues = form.getFieldsValue();
        }
    }, [formReloadCount]);
    useEffect(() => {
        (propsForm ?? form).setFieldsValue({ ...defaultValue })
    }, [defaultValue])
    return (
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Form.Item
                        name={"role_property_json_id"}
                        hidden
                    >
                    </Form.Item>
                    <Form.Item
                        name={"property_json"}
                    >
                        <PropertyJson />
                    </Form.Item>
                </Form>
            </Col>
        </Row>
    );
}

const BindRoleButton = () => {
    const [form] = Form.useForm();
    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false)

    const onFormFinish = (value) => {
        let { ...formValues } = form.getFieldsValue()
        rolePropertyJsonController.patchData([formValues]);
    }

    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "get") {
            } else if (axiosMode === "post") {
                message.success("新增成功");
            } else if (axiosMode === "patch") {
                message.success("修改成功");
            } else if (axiosMode === "delete") {
                message.success("刪除成功");
            }
            if (axiosMode !== "get") {
                setModalOpen(false);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗");
            } else if (axiosMode === "patch") {
                message.error("修改失敗");
            } else if (axiosMode === "delete") {
                message.error("刪除失敗");
            }
            setModalOpen(false);
        }
    }
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    }
    const rolePropertyJsonController = useCRUDController({
        onBefore,
        onFinish,
        apiRoute: '/organization_structure/api/role_property_json'
    })
    useEffect(() => {
        const values = rolePropertyJsonController.ResponseData
        if (values.length !== 0) {
            form.setFieldsValue({ ...values?.find(_ => true) })
        }
    }, [rolePropertyJsonController.ResponseData])
    useEffect(() => {
        rolePropertyJsonController.getData()
    }, [])

    return (
        <>
            <Button
                type="primary"
                style={{
                    color: "#000",
                    backgroundColor: "#C5D3E8",
                }}
                onClick={(e) => { setModalOpen(true) }}
            >
                職位綁定
            </Button>
            <MainModal
                axiosMode="patch"
                propsForm={form}
                propsOpen={modalOpen}
                propsSetOpen={setModalOpen}
                onFinish={onFormFinish}
                width={1000}
                formElement={<BindRoleForm></BindRoleForm>}
                keyPrefix
            />
        </>
    )
}

const BindRoleForm = ({
    propsForm = null,
    propsValue = null,
    formReloadCount = 0,
    onFormFinish = () => { },
    customFormItems = () => { },
    defaultValue = {},
    propsOnValuesChange = () => { },
    fieldName
}) => {
    const [form] = Form.useForm();
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });
    };
    const onValuesChange = (value, { name, type }) => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldsValue();
        } else {
            formValues = form.getFieldsValue();
        }
        propsOnValuesChange(formValues)
    };
    useEffect(() => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldsValue();
        } else {
            formValues = form.getFieldsValue();
        }
    }, [formReloadCount]);
    useEffect(() => {
        (propsForm ?? form).setFieldsValue({ ...defaultValue })
    }, [defaultValue])
    return (
        <Row>
            <Col span={24}>
                <Form
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Form.Item
                        name={"role_property_json_id"}
                        hidden
                    >
                    </Form.Item>
                    <Form.Item
                        name={"property_json"}
                    >
                        <DepartmentRoleManagement
                            mode={'role'}
                            key={'role'}
                            actionMode={'readOnly'}
                            defaultSelectedRowsInfo={[]}
                            defaultSelectedRowsKeys={[]}
                            onSelectChange={(roles) => {
                                roles.map((role, index) => {
                                    console.log(role)
                                    console.log(role.role_id)
                                })
                            }}
                        />
                        {/* <PropertyJson /> */}
                    </Form.Item>
                </Form>

            </Col>
        </Row>
    );
}



/*
<TreeSelectLazy
                multiple
                allowClear
                treeDefaultExpandAll
                apiRoot={'/organization_structure/api/department_dropdown'}
                propsTreeData={[
                    {
                        ...department,
                        children: []
                    }
                ]}
            />
            */
const TreeSelectLazy = ({ name, apiRoot, propsTreeData, ...props }) => {
    const [treeData, setTreeData] = useState([]);
    const [loading, setLoading] = useState(false);
    const cacheRef = useRef({});  // 快取已載入過的子樹

    // 初次載入第一層
    useEffect(() => {
        setTreeData(propsTreeData.map(node => ({ ...node, isLeaf: false })));
        cacheRef.current['root'] = propsTreeData;
    }, [propsTreeData]);

    // 當某節點要展開時呼叫
    const handleLoadData = (nodeValue) => {
        // 如果已經載過，就不再呼叫
        if (cacheRef.current[nodeValue]) return Promise.resolve();
        setLoading(true);

        return axios.get(`${apiRoot}`, {
            params: {
                classify_structure_type_id: nodeValue,
                all: true
            }
        })
            .then(res => {
                // 找到那個節點，並插入 children
                const insertChildren = (nodes) => {
                    return nodes.map(n => {
                        if (n.value === nodeValue) {
                            cacheRef.current[nodeValue] = res.data?.data;
                            return {
                                ...n,
                                children: res.data?.data.map(c => ({ ...c, children: [], isLeaf: false }))
                            };
                        }
                        if (n.children) {
                            return { ...n, children: insertChildren(n.children) };
                        }
                        return n;
                    });
                };
                setTreeData(old => insertChildren(old));
            })
            .finally(() => setLoading(false));
    };

    return (
        <Spin spinning={loading} tip="展開中…">
            <TreeSelect
                {...props}
                treeData={treeData}
                loadData={(node) => handleLoadData(node.value)}  // 自訂屬性
                treeDefaultExpandAll={false}
            />
        </Spin>
    );
};
export { TreeSelectLazy }